@if (visible()) {
  <div
    class="loading-state"
    [class.loading-state-section]="mode() === 'section'"
    role="status"
    aria-live="polite"
    [attr.aria-label]="label()"
  >
    <mat-spinner [diameter]="mode() === 'section' ? 40 : 24" />
    <span>{{ label() }}</span>
  </div>
}
